import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { IVotingQuestions } from "../../models/VotingQuestions";
import { EmptyVotingQuestions } from "../../models/VotingQuestions";
import { JVDate } from "../../shared/JVDate";


const schema = yup.object({
    question: yup.string().required("Voting Qusetion is required*"),
    expiry_Date: yup.date().required("Expiry Date is required*")
});

interface Iprops {
    singleData: IVotingQuestions,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IVotingQuestions>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
       
    }, [props.singleData])

   

    useEffect(() => {
    }, []);

    

    const saveToDB = async (body: IVotingQuestions) => {
        const method = props.singleData.question? "PUT" : "POST";
        const message = props.singleData.question ? "Updated Successfully" : "Added Successfully";

      

        const response = await Fetch("Voting_Questions", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyVotingQuestions);
    }

    function onSubmit(data: IVotingQuestions) {
       
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} header="Add/Edit Questions" modal className="p-fluid w-8" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput required label="Question Name" control={control} name="question" error={errors.question?.message} />
                <JVDate minDate={new Date} column={3} label="Expiry Date" required control={control} name="expiry_Date" error={errors.expiry_Date?.message} />
                <div className="field col-12 md:col-12">
                    <Button className="mt-3" label="SAVE" type="submit"></Button>
                    <Button className="p-button-outlined mt-3" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}
